import React, { useEffect } from 'react';
import Typeahead from '../../Typeahead';
import { FieldSelector } from '../../cart';
import Checkbox from '../../Checkbox';
import Cta from '../../Cta';
import { translate } from '@micro-apps/env';
import ErrorMessage from '../ErrorMessage';

interface FindReservationFormProps {
	isPersistentlySignedIn: boolean;
	isError: boolean;
	properties: any;
	property: any;
	setIsError: (isError: boolean) => void;
	handleReservationSubmit: (reservationNumber, lastName, hotelCode) => void;
}

const FindReservationForm: React.FC<FindReservationFormProps> = ({
	isPersistentlySignedIn,
	isError,
	property,
	properties,
	setIsError,
	handleReservationSubmit,
}) => {
	const hotelCode = window.FS?.['propertyInfo']?.owsCode;
	const [reservationForm, setReservationForm] = React.useState({
		reservationLocation: hotelCode || '',
		reservationNumber: '',
		lastName: '',
		isConfirmed: false,
	});

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setReservationForm(prevState => ({
			...prevState,
			[name]: value,
		}));
	};

	const getPropertyItem = (property, i: number) => {
		return (
			<button
				key={i}
				className="DestinationPicker-item"
				type="button"
				onClick={() => {
					setReservationForm(prevState => ({
						...prevState,
						reservationLocation: property.owsCode,
					}));
				}}
			>
				<span
					className="body-2 PropertyTitle"
					dangerouslySetInnerHTML={{
						__html: window['FS']?.['resizeBeverlyWilshire'](
							property.shortName ? property.shortName : property.officialName
						),
					}}
				/>
				<span className="body-2 PropertySubtitle">
					{property?.location?.enCountry && translate(property.location.enCountry)}
				</span>
			</button>
		);
	};

	return (
		<div className="find-reservation otp-sign-in">
			<h1 className="heading-2">{translate('Find a Reservation')}</h1>
			<p className="intro body-2">{translate('Please enter your reservation details.')}</p>
			{isError && (
				<ErrorMessage
					message={translate(
						'The information you entered does not match a current reservation in our system. Please check the information entered and try again. For assistance, please contact the Hotel or Resort directly.'
					)}
				/>
			)}
			<form className="request-otp body-2">
				{property ? (
					<p className="subtitle-1 location-name">{property.propertyOfficialName}</p>
				) : (
					<Typeahead
						id="reservationLocation"
						inputClassName="TextInput-field formElement-field ty-b2"
						placeholder={translate('Reservation Location')}
						data={properties?.map((property, i) => ({
							node: getPropertyItem(property, i),
							search: property.shortName ? property.shortName : property.officialName || '',
						}))}
						noResults={''}
						setValueOnCLick={true}
					/>
				)}

				<FieldSelector
					type="TEXT"
					value={reservationForm.lastName}
					label={translate('Last Name*')}
					name="lastName"
					readOnly={isPersistentlySignedIn}
					onChange={e => {
						handleInputChange(e);
						isError && setIsError(false);
					}}
					field=""
					form=""
					styles=""
					content=""
				/>
				<FieldSelector
					type="TEXT"
					value={reservationForm.reservationNumber}
					label={translate('Confirmation Number*')}
					name="reservationNumber"
					readOnly={isPersistentlySignedIn}
					onChange={e => {
						handleInputChange(e);
						isError && setIsError(false);
					}}
					field=""
					form=""
					styles=""
					content=""
				/>

				<Checkbox
					className="body-2"
					label="I confirm that I am the guest and/or individual authorized and responsible for the requested reservation and payment details."
					checked={reservationForm.isConfirmed}
					onChange={e => {
						setReservationForm(prevState => ({
							...prevState,
							isConfirmed: e.target.checked,
						}));
					}}
				/>
				<div className="confirm-buttons">
					<Cta
						type="primary"
						disabled={
							!reservationForm.reservationLocation ||
							!reservationForm.reservationNumber ||
							!reservationForm.lastName ||
							!reservationForm.isConfirmed
						}
						onClick={() =>
							handleReservationSubmit(
								reservationForm.reservationNumber,
								reservationForm.lastName,
								reservationForm.reservationLocation
							)
						}
						className="button-filled"
					>
						{translate('Find Reservation')}
					</Cta>
				</div>
				{isError && (
					<div>
						<div className="call-us body-2">
							<p>{translate('If you are having problems signing in, please call us.')}</p>
							<div className="body-2 other-toll-fee">
								<a href="tel:+18008195053">+1 (800) 819-5053</a>{' '}
								<a href="/global-toll-free-telephone-numbers/">
									{translate('Other Toll-Free Numbers')}
								</a>
							</div>
						</div>
					</div>
				)}
			</form>
		</div>
	);
};

export default FindReservationForm;
